<a class="d-flex flex-column ca-module-item" [routerLink]="detailLink" data-uit="module-item">
    <div class="thumbnail d-flex" [style.backgroundImage]="shownVersion?.image ? 'url(' + shownVersion?.image + ')' : ''">
        <div class="badge-and-ribbon-container d-flex">
            <ca-module-badge class="badge-position me-1" *ngIf="isInWorkspace && showBanner && moduleLabelKey" [labelKey]="moduleLabelKey"></ca-module-badge>
            <ca-ribbon
                *ngIf="showRibbon"
                class="ribbon ms-3 mb-2"
                [class.is-compliant]="isCompliant && !module.isFeatured"
                label="{{ (module.isFeatured ? 'GENERAL.FILTERS.FEATURED' : 'GENERAL.FILTERS.COMPLIANT') | translate }}"
                data-uit="module-item-ribbon"
            ></ca-ribbon>
        </div>
    </div>
    <div class="d-flex flex-column info-others p-3" tabindex="0">
        <p class="version font-sm" title="{{ shownVersion?.versionNumber | moduleVersionNumber }}">
            {{ shownVersion?.versionNumber | moduleVersionNumber }}
        </p>
        <h4 class="title overflow-hidden" title="{{ module?.title }}" data-uit="module-item_title">{{ module?.title }}</h4>
        <a
            class="title font-sm overflow-hidden search-engine-indexing-link"
            href="{{ 'modules/' + detailLink[1] + '/' + detailLink[2] }}"
            title="{{ module?.title }}"
            >{{ module?.title }}
        </a>
    </div>
    <span *ngIf="isLoggedIn" class="author d-flex align-items-center overflow-hidden font-sm px-3 py-2" data-uit="module-author">
        {{ 'MODULES.CREATED_BY' | translate }}
        <a *ngIf="module?.author" class="ms-1" (click)="$event.stopPropagation()" [routerLink]="profileLink" [title]="module?.author | fullName">
            {{ module?.author | fullName }}
        </a>
        <p *ngIf="!module?.author" class="ms-1">{{ 'GENERAL.ARIVIS_CLOUD' | translate }}</p>
    </span>
</a>
